var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTurnDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.497 365.801L197.498 509.797C194.436 512.734 189.561 512.734 186.498 509.797L34.5 365.801C31.281 362.77 31.156 357.708 34.187 354.489C37.25 351.302 42.312 351.146 45.5 354.177L183.999 485.376V71.998C183.999 41.124 158.874 16 127.999 16H8C3.594 16 0 12.406 0 8S3.594 0 8 0L127.999 0C167.686 0 199.998 32.312 199.998 71.998V485.376L338.497 354.177C340.028 352.708 342.028 351.989 343.997 351.989C346.122 351.989 348.247 352.833 349.81 354.489C352.841 357.708 352.716 362.77 349.497 365.801Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTurnDown);
export default __webpack_public_path__ + "static/media/arrow-turn-down.c8fe99946e8802f26ebec36da33202b3.svg";
export { ForwardRef as ReactComponent };